import AuthService from './authService.js';

class LogService 
{
    
    static GetLogByEntityTypeIdAndEntityId(entityType, entityId)
    {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Log/GetLog/?"
                +"entityType="+entityType
                +"&entityId="+entityId
            );
    }

}

export default LogService;